import { useMutation } from '@tanstack/react-query';

import { useStoreApi } from '../api';

const useCancelSubscription = () => {
  const StoreApi = useStoreApi();

  const cancelSubscription = async ({
    subscriptionId,
    causeId,
  }: {
    subscriptionId?: string;
    causeId?: string;
  }) => {
    const { data } = await StoreApi.delete(
      `/subscriptions/${subscriptionId}?cart=true&cause_id=${causeId}`
    );
    return data;
  };

  return useMutation({ mutationFn: cancelSubscription });
};

export { useCancelSubscription };
